<template>
  <div class="footer">
    <p>澳覓©{{new Date().getFullYear()}} 技術支持：澳門網絡傳媒發展有限公司</p>
    <p><a href="http://beian.miit.gov.cn"
         target="blank">粤ICP备16081851号</a></p>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.footer {
  width: 1200px;
  margin: auto;
  padding: 30px 120px;
  display: flex;
  justify-content: space-between;
  p {
    font-size: 15px;
    font-weight: 500;
    a {
      color: #2c3e50;
    }
  }
}
</style>